import { render, staticRenderFns } from "./channelColumn.vue?vue&type=template&id=75e2b344&scoped=true"
import script from "./channelColumn.vue?vue&type=script&lang=js"
export * from "./channelColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e2b344",
  null
  
)

export default component.exports